import { Component, OnInit } from '@angular/core';
import { ApiRestService } from "../api-rest.service";
import { ServerPaginationService } from "../../shared/_services/server-pagination.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Materiale } from "../_Models/materiale";
import { Categorie } from 'src/app/Progetti/Models/Categorie';
import { IDropdownSettings } from "../../../LibrerieCustom/MultiselectDropdown";
import { ClassicType } from "../../shared/models/ClassicType";
import { DatePipe, Location } from "@angular/common";
import { TranslateObj } from "../../shared/models/translatedesc";
import { Azienda } from "../../Admin/models/Azienda";
import { ApiRestService as ClientiApiRestService } from "../../Admin/_service/api-rest.service";
import { environment } from "../../../environments/environment";
import { ToastrService } from "ngx-toastr";
import { Prodotto } from "../../Progetti/Models/Prodotto";
import { ApiPathsService } from "../../api-paths.service";
import { Lavorazione } from 'src/app/acquisti/_Models';

@Component({
  selector: 'app-materiali-edit',
  templateUrl: './materiali-edit.component.html',
  styleUrls: ['./materiali-edit.component.css']
})
export class MaterialiEditComponent implements OnInit {
  environment = environment;
  DropdownSources: any = {};
  private Tipo: string;
  Materiale: Materiale = new Materiale();
  Categorie: Categorie[] = [];
  CategorieSelezionate: Categorie[] = [];
  UM: ClassicType[] = [];
  UMSelezionate: ClassicType[] = [];
  DropdownSettings: IDropdownSettings = {
    singleSelection: true,
    enableCheckAll: false,
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    textField: "categoria",
  };
  partiDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    enableCheckAll: false,
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    textField: "categoria",
  };
  SingleClassicTypeDownSettings: IDropdownSettings = {
    singleSelection: true,
    enableCheckAll: false,
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    textField: 'label',
  };
  clientiDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'nominativo',
    allowSearchFilter: true,
    singleOutput: true
  };
  Fornitori: Azienda[] = [];
  PartiEcommerce: any;
  PartiEcommerceSelezionate: any[];
  paginationValue = {
    page: 1,
    pageSize: 10,
    pagesizeserver: 2,
    newpagegenerated: 1,
  }
  Acquisti: { total: number, data: any[], stampe: any[] } = { total: 0, data: [], stampe: [] };;
  constructor(
    private apiRest: ApiRestService,
    private paginationService: ServerPaginationService,
    private route: ActivatedRoute,
    public router: Router,
    private location: Location,
    private clientiApiRest: ClientiApiRestService,
    private toastService: ToastrService,
    private apiPaths: ApiPathsService,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(data => {
      this.Tipo = data['type'];
      this.Refresh(parseInt(data['id']));
    });
    this.Materiale.transaltedobjects = this.createlang(["en", "es", "fr", "de"]);
  }

  private Refresh(number?: number) {
    this.apiRest.getPartiTypes().subscribe(data => {
      console.log(data.find(x => parseInt(x.id.toString()) == parseInt(this.Tipo)));
      this.apiRest.GetCategorieList(data.find(x => parseInt(x.id.toString()) == parseInt(this.Tipo))).subscribe(cat => {
        this.Categorie = cat;
      });
    })
    this.clientiApiRest.getListaAziende({ ruolo: "F", page: 0, size: 10 }).subscribe(data => {
      this.Fornitori = data?.data;
    });

    this.apiRest.getUnitaDiMisura().subscribe(data => this.UM = data);
    if (number)
      this.apiRest.getInfoParte({ id: number }).subscribe(materiale => this.compile(materiale))
    else
      this.compile(new Materiale());
  }

  private compile(materiale: Materiale) {
    this.PartiEcommerce = [];
    if (materiale?.categorieObject?.length > 0)
      this.Materiale = materiale;
    this.Materiale.UrlImmagine = !isNaN(this.Materiale.id_immagine) ? `${this.apiPaths.getBaseAPI()}/file/image/${this.Materiale.id_immagine.toString()}` : undefined;

    this.UMSelezionate = materiale?.umObject ? [materiale?.umObject] : [];
    this.CategorieSelezionate = materiale?.categorieObject ?? [];
    this.PartiEcommerceSelezionate = materiale?.partiEcObject ?? [];
    this.Materiale.transaltedobjects = materiale.id ? this.gettransaltedobjects(materiale) : this.createlang(["en", "es", "fr", "de"]);
    this.GetAcquistiParte(1);
  }
  private getData() {
    this.Materiale.categorie = this.CategorieSelezionate.map(x => x?.id);
    this.Materiale.partiEc = this.PartiEcommerceSelezionate.map(x => x?.id);
    this.Materiale.um_id = this.UMSelezionate?.length > 0 ? parseInt(this.UMSelezionate[0]?.id?.toString()) : undefined
    this.Materiale.tipo = parseInt(this.Tipo);
    return this.Materiale;
  }

  saveClick() {
    if (this.Materiale?.id)
      this.apiRest.updateParti(this.getData()).subscribe(() => {
        this.location.back();
      })
    else
      this.apiRest.addParti(this.getData()).subscribe(() => {
        this.location.back();
      })
  }

  FornitoreChange(fornitore: Azienda, materiale: Materiale) {
    materiale.fornitore = fornitore?.id
  }


  createlang(values: string[]): TranslateObj[] {
    var output: TranslateObj[] = [];
    output.push({
      default: true,
      lang: "it",
      TranslateInputs: [
        { id: "nome", label: "Nome", value: "", type: "text" },
      ]
    })
    values?.forEach(value => {
      output.push({
        default: false,
        lang: value,
        TranslateInputs: [
          { id: "nome", label: "Nome", value: "", type: "text" },
        ]
      })
    })
    return output;
  }

  gettransaltedobjects(materiale: Materiale): TranslateObj[] {
    return [
      {
        default: true,
        lang: "it",
        TranslateInputs: [
          { id: "nome", label: "Nome", value: materiale.nome, type: "text" },
        ]
      }
    ].concat(materiale.traduzioni);
  }

  async ImageChange(event, target, type: 'image' | 'pdf', filename?) {
    const blob: Blob = event.target.files[0];
    if (!blob.type.includes(type)) {
      this.toastService.warning("Questo formato non è supportato. Inserire solo " + type + ".", "Attenzione!")
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = () => {
      this.Materiale[target] = reader.result.toString().length > 1 ? reader.result.toString() : undefined;
      if (!filename) return;
      this.Materiale[filename] = reader.result.toString().length > 1 ? event.target.files[0].name : this.Materiale[filename];
    };
  }
  onImageError(prodotto: Materiale) {
    // prodotto.UrlImmagine = 'assets/images/gallery/NoImageAvailable.png';
  }


  Change($event: { OnChange: string; Event: any; CampoAggiuntivo?: any }) {

  }
  getPage(page: number) {
    this.paginationValue.page = this.paginationService.paginadellalista(page, this.paginationValue.pagesizeserver);
    const pagetosend = this.paginationService.getPage(page, this.paginationValue.newpagegenerated, this.paginationValue.pagesizeserver);
    if ((pagetosend - 1) % this.paginationValue.pagesizeserver === 0) {
      this.paginationValue.newpagegenerated = page;
      this.GetAcquistiParte(pagetosend);
    }
  }
  GetAcquistiParte(page, id?: number) {
    var filter = { parte_id: this.Materiale?.id, page: ((page ?? 1) - 1) / this.paginationValue.pagesizeserver + 1, size: this.paginationValue.pagesizeserver * this.paginationValue.pageSize, };
    this.apiPaths.ClassicPost('/primanota/acquisti/voci/prodotto', filter).subscribe(Acquisti => {
      this.Acquisti = Acquisti;
    });

  }
  Arrivati(data) {
    if (data && data?.item?.consegnati != data?.item?.quantita) {
      var stock = new Lavorazione(data.item?.id);
      stock.data = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      stock.quantita = data.item?.quantita;
      this.apiPaths.ClassicPost('/primanota/stock/add', stock).subscribe(() => {
        this.GetAcquistiParte(1,)
        this.toastService.success('Operazione eseguita con successo')
      })
    } else {
      this.toastService.warning('Questo Prodotto è stato già consegnato in precedenza')
    }
  }
}
